import { render } from "./BaseConfirmationModal.vue?vue&type=template&id=3bd55c58&scoped=true"
import script from "./BaseConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BaseConfirmationModal.vue?vue&type=script&lang=js"

import "./BaseConfirmationModal.vue?vue&type=style&index=0&id=3bd55c58&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd55c58"]])

export default __exports__